var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.91832 20H12.0408V11.9184H19.5102V8.08163H12.0408V0H7.91832V8.08163H0.489746V11.9184H7.91832V20Z","fill":"#555555"}));
}

PlusInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
